import React from "react";

const AddressLoader = () => {
  return (
    <div className="border-primary-light/30 animate-pulse space-y-3 rounded-md border p-4">
      <div className="flex flex-wrap items-center justify-between">
        <div className="h-6 w-1/4 rounded bg-gray-200" />
        <div className="flex gap-2.5">
          <div className="h-5 w-12 rounded bg-gray-200" />
          <div className="h-5 w-12 rounded bg-gray-200" />
        </div>
      </div>
      <div className="space-y-2.5">
        <div className="h-5 w-2/3 rounded bg-gray-200" />
        <div className="h-5 w-1/2 rounded bg-gray-200" />
        <div className="h-5 w-1/3 rounded bg-gray-200" />
      </div>
    </div>
  );
};

export default AddressLoader;
